module.exports = __webpack_public_path__ + "static/media/mps1_v2.7c9f5725.jpg";